// extracted by mini-css-extract-plugin
export default {"section":"Yu-z","sectionTitle":"Zu-z","fieldWrapper":"_u-z","formField":"av-z","disabled":"bv-z","formLabel":"cv-z"};